import React from "react";
import { stats } from "../data/landing";
export function StatsStrip() {
  return <section className="stats-band" aria-label="Kit at a glance" data-id="element-201" data-mp="ghf7ebxmgv5j">
      <dl className="shell stats-grid" data-id="element-202" data-mp="gfkhskbeoev4">
        {stats.map(stat => <div key={stat.label} data-id="element-203" data-mp="2j7ag40l5tud">
            <dt data-id="element-204" data-mp="2k8o8g8zkufs">{stat.label}</dt>
            <dd data-id="element-205" data-mp="7ggzhik2c3ho">{stat.value}</dd>
          </div>)}
      </dl>
    </section>;
}